<div class="modal-header">
  <h3 class="modal-title">Attention, vos changements vont remettre le calcul en Brouillon</h3>
</div>
<div class="modal-body">
  <p>En modifiant les valeurs du formulaire, il se pourrait que les résultats ne soient plus à jour dans la section
    résultat tant que le calcul n'aura pas été roulé de nouveau</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-light" data-bs-dismiss="modal" type="button">Ne pas
    sauvegarder
  </button>
  <button (click)="activeModal.close(true)" class="btn btn-primary" type="button">Oui, je veux sauvegarder</button>
</div>
